import { apmBase } from '@elastic/apm-rum';
import type { AxiosResponse } from 'axios';

const missingHttpRefererHeader = 'x-missing-http-referer';
const maxRecentRouteCount = 5;

let hasLoggedMissingHttpReferer = false;
const recentRoutes: string[] = [];

export function recordRecentRoute(fullPath: string): void {
    recentRoutes.push(fullPath);
    if (recentRoutes.length > maxRecentRouteCount) {
        recentRoutes.shift();
    }
}

function getReferrerPolicyMeta(): string {
    return document.querySelector('meta[name="referrer"]')?.getAttribute('content') ?? 'none';
}

export function logMissingHttpReferer(response: AxiosResponse | undefined): void {
    if (hasLoggedMissingHttpReferer || response?.headers?.[missingHttpRefererHeader] !== 'true') {
        return;
    }
    hasLoggedMissingHttpReferer = true;

    const method = response.config.method?.toUpperCase() ?? 'UNKNOWN';
    const details = [
        `request: ${method} ${response.config.url ?? ''}`,
        `page: ${window.location.href}`,
        `documentReferrer: ${document.referrer || 'empty'}`,
        `hasOpener: ${window.opener !== null}`,
        `visibility: ${document.visibilityState}`,
        `referrerPolicyMeta: ${getReferrerPolicyMeta()}`,
        `recentRoutes: ${recentRoutes.join(' -> ') || 'none'}`,
    ].join(', ');

    apmBase.captureError(new Error(`Request sent without HTTP referer (${details})`));
}
